import { SECRET_KEY} from "../site.config";
import hmacSHA256 from 'crypto-js/hmac-sha256';

export function generateAuthorization(data){
    let stingData = JSON.stringify(data)
    const hmacDigest =hmacSHA256(stingData, SECRET_KEY);
    return hmacDigest;

}